export default {
    route: {
        home: '首页',
        systemManage: '系统管理',
		informationManage:'信息管理',
		realTimeData:'实时数据',
		workshopMessage:'车间信息',
        userList: '用户列表',
        addUser: '添加用户',
        updateUser: '修改用户',
        deleteUser: '删除单用户',
        deleteMultiUser: '删除多用户',
        resetPassword: '重置密码',
        assignRole: '为用户分配角色',
        roleList: '角色列表',
        selectAllRole: '查询所有角色',
        selectRolePermission: '查询角色权限',
        addRole: '添加角色',
        updateRole: '修改角色',
        deleteRole: '删除角色',
        deleteMultiRole: '删除多角色',
        assignPermission: '为角色分配权限',
        schedule: '定时任务',
        errorPages: '错误页面',
        page401: '401',
        page404: '404',
        wxManage: '微信管理',
        wxAccount: '公众号账号',
        wxAccountSave: '保存公众号',
        wxAccountDelete: '删除公众号',
        wxMenu: '公众号菜单',
        wxUser: '粉丝管理',
        msgTemplate: '模板消息',
        wxQrCode: '带参二维码',
        msgReplyRule: '自动回复规则',
        wxMsg: '公众号消息',
        wxAssets: '素材管理',
        swiper: '轮播图',
        chartAnalysis: '图表分析',
        farinogram: '粉质仪曲线',
        realFlow: '实时流量曲线',
        historyFlow: '历史流量曲线',
        formulaManage: '配方设定',
        wheatFormula: '配麦配方',
        flourFormula: '配粉配方',
        addWheatFormula: '添加配麦配方',
        addFlourFormula: '添加配粉配方',
        verifyWheatFormula: '审核配麦配方',
        verifyFlourFormula: '审核配粉配方',
        sendWheatFormula: '发送配麦配方',
        sendFlourFormula: '发送配粉配方',
        materialManage: '物料管理',
        productionSchedule: '生产排产',
        wheatFormulaSchedule: '配麦排产',
        flourFormulaSchedule: '配粉排产',
        wheatPourSchedule: '倒麦排产',
        flourPourSchedule: '倒粉排产',
        wheatFormulaProd: '配麦排产',
        flourFormulaProd: '配粉排产',
        receiveWheatFormula: '接收配麦配方',
        receiveFlourFormula: '接收配粉配方'
    },
    navbar: {
        home: '首页',
        logOut: '退出登录',
        profile: '个人中心',
        theme: '换肤',
        size: '布局大小'
    },
    login: {
        title: '系统登录',
        logIn: '登录',
        username: '账号',
        password: '密码',
        any: '随便填'
    },
    profile: {
        profile: '个人中心',
        username: '用户名',
        role: '角色',
        avatar: '头像',
        password: '密码',
        changePassword: '修改密码',
        oldPassword: '原密码',
        newPassword: '新密码',
        confirmNewPassword: '确认新密码',
        oldPasswordTip: '请输入原密码',
        newPasswordTip: '请输入新密码',
        confirmNewPasswordTip: '请再次输入新密码',
        telephone: '手机号',
        realName: '真实姓名',
        nickname: '昵称',
        lastLoginTime: '最后登录时间',
        createUser: '创建人'
    },
    role: {
        roleCode: '角色代码',
        roleName: '角色名',
        roleDesc: '角色说明',
        roleLevel: '角色级别',
        Menus: '权限菜单',
        handle:'操作',
        total:''
    },
    table: {
        search: '搜索',
        add: '添加',
        export: '导出',
        id: '序号',
        actions: '操作',
        edit: '编辑',
        delete: '删除',
		cancellation:"作废",
        create: '创建',
        update: '修改',
        cancel: '取 消',
        confirm: '确 定',
        batchDelete: '批量删除',
        access: '接入',
        copy: '复制',
        save: '保存',
        creator:"创建人",
        createTime:"创建时间",
        verify: '审核',
        send: '发送',
        receive: '接收'
    },
    tagsView: {
        refresh: '刷新',
        close: '关闭',
        closeOthers: '关闭其它',
        closeAll: '关闭所有'
    },
    settings: {
        title: '系统布局配置',
        theme: '主题色',
        tagsView: '开启 Tags-View',
        fixedHeader: '固定 Header',
        sidebarLogo: '侧边栏 Logo'
    },
    wx: {
        wxName: '公众号名称',
        wxType: '账号类型',
        verified: '是否认证',
        accessInfo: '开发接入信息',
        accessUrl: '接入链接',
        selectMaterial: '选择素材',
        pCPreview: '管理后台不支持预览',
        wechatPlayed: '微信中可正常播放',
        saveUrl: '保存地址',
        linkUrl: '跳转链接',
        rank: '排序(升序)'
    },
    oss: {
        cloudStorage: '云存储配置',
        batchDelete: '批量删除',
        createTime: '创建时间',
        storageType: '存储类型',
        qiNiu: '七牛',
        aliCloud: '阿里云',
        qCloud: '腾讯云',
        domain: '域名',
        pathPrefix: '路径前缀',
        spaceName: '空间名',
        domainTips: '七牛绑定的域名',
        prefixTips: '不设置默认为空',
        accessKeyTips: '七牛AccessKey',
        secretKeyTips: '七牛SecretKey',
        spaceTips: '七牛存储空间名',
        aliDomainTips: '阿里云绑定的域名',
        endPointTips: '阿里云EndPoint',
        accessKeyIdTips: '阿里云AccessKeyId',
        accessKeySecretTips: '阿里云AccessKeySecret',
        bucketTips: '阿里云BucketName',
        tencentDomainTips: '腾讯云绑定的域名',
        appIdTips: '腾讯云AppId',
        secretIdTips: '腾讯云SecretId',
        qCloudSecretKeyTips: '腾讯云SecretKey',
        qBucketTips: '腾讯云BucketName',
        bucketRegion: 'Bucket所属地区',
        regionTips: '如：sh（可选值 ，华南：gz 华北：tj 华东：sh）'
    },
    formula: {
        formulaAdd: '添加配方',
        formulaUpdate: '修改配方',
        formulaNo: '配方编号',
        formulaName: '配方名称',
        batchNo: '批次号',
        productionLine: '生产线',
        processName: '工艺段',
        variety: '品种',
        storeNo: '仓号',
        ratio: '比例',
        batchWeight: '总重量',
        weight: '重量',
        mixTime: '混合时间',
        flourRatio: '面粉占比',
        totalFlow: '总流量',
        setWater: '设定水分',
        processVolume: '加工量',
        manualAdd: '人工添加',
        flourBatchWeight: '面粉批重',
        traceBatchWeight: '微量总重',
        excBatchWeight: '辅料批重',
        verifyState: '审核状态',
        sendState: '发送状态',
        receiveState: '接收状态'
    },
    taskList: {
        taskIdWhole: '任务号'
    },
    material: {
        materialType: '物料类型',
        secondMaterialType: '物料二级类型',
        materialName: '物料名称'
    }
}
